export default "__VITE_ASSET__Dm3RaoI9__"